import { useStaticQuery, graphql } from "gatsby";

export const GetFaqs = () => {
  const data = useStaticQuery(graphql`
    query {
      allWpFaq(limit: 6) {
        nodes {
          faqTitle
          faqDescription
        }
      }
    }
  `);

  return data.allWpFaq.nodes;
};
